import { ReactComponent as Logo } from './crush_logo.svg';

export function CrushLogo(props: React.SVGProps<SVGSVGElement>) {
  return <Logo {...props} />;
}
